import { IBase } from "src/app/core/models/base";
import { IGetServiceAttachment, IServiceAttachment } from "./service-attachment";
import { IServicePart } from "./service-part";
import { IRevisionStatus } from "src/app/revisions/models/revision-status";

export interface IService extends IBase{
    description : string,
    status : ServiceStatus,
    dateScheduled : Date,
    dateExecuted : Date,
    deviceWear : DeviceWear,
    devicePollution : DevicePollution,
    deviceId : string,
    revisionId : string,
    updateStatusEmployeeId: string,
    maintainerFirstName: string,
    maintainerLastName: string,
    serviceAttachments: IServiceAttachment[],
    cancellationMessage?: string,
    cancelMessage?: string,
    serviceParts: IServicePart[],
    remark?: string,
    lastModifiedOn: Date
}

export interface ICreateServiceRequest {
    dateScheduled : Date,
    dateExecuted : Date,
    description : string,
    status : ServiceStatus,
    deviceId : string
}

export interface ICreateClientServiceRequest {
    dateExecuted : Date,
    description : string,
    deviceId : string
}

export interface IUpdateServiceRequest {
    id: string,
    description? : string,
    dateScheduled? : Date,
    dateExecuted? : Date,
    deviceWear? : DeviceWear,
    devicePollution? : DevicePollution,
    remark?: string,
    cancellationMessage?: string
}

export interface IUpdateClientServiceRequest {
    id: string,
    description? : string,
    dateExecuted? : Date
}

export interface IUpdateServiceStatusRequest {
    id: string,
    status: ServiceStatus,
    revisionId: string,
    cancellationMessage?: string
}

export interface IUpdateServiceStatusResponse {
    id: string,
    status: ServiceStatus,
    employeeFirstName: string,
    employeeLastName: string,
    lastModifiedOn: Date,
    cancellationMessage: string
}

export interface IServiceDetailsResponse {
    id: string,
    dateScheduled : Date,
    dateExecuted : Date,
    description : string,
    status : ServiceStatus,
    type : ServiceType,
    deviceWear : DeviceWear,
    devicePollution : DevicePollution,
    maintainerFirstName: string,
    maintainerLastName: string,
    serviceAttachments: IGetServiceAttachment[],
    serviceParts: IServicePart[],
    revisionStatus: IRevisionStatus,
    remark?: string,
    cancellationMessage?: string
}

export enum DevicePollution {
    Light = 10,
    Medium = 20,
    Heavy = 30
}

export enum DeviceWear
{
    Light = 10,
    Medium = 20,
    Heavy = 30
}

export enum ServiceStatus
{
    Open = 10,
    Maintained = 20,
    NotMaintained = 30,
}

export enum ServiceType
{
    Default = 10,
    Client = 20
}